import { connect } from 'react-redux';
import { changeStep } from '../actions/wizardActions';
import Introduction from '../components/Introduction/Introduction';

const mapDispatchToProps = { changeStep };

export default connect(null, mapDispatchToProps)(Introduction);
